import React, { useState } from "react";
import { Modal, Select, message } from "antd";
import CalendarIcon from "../../../assets/promotion-calendar.svg";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { generateInvoiceValidation } from "../../../utils/validations/formValidations";
import "./generateInvoice.css";
import { CaretDownOutlined } from "@ant-design/icons";
import { GenerateTransactionHistoryData } from "../../../utils/api";
import { downloadExcelFile } from "../../../utils/storageUtil";

const options = [
  { key: "paid,pending,failed,refunded", label: "All" },
  { key: "paid", label: "Paid" },
  { key: "pending", label: "Pending" },
  { key: "refunded", label: "Refunded" },
  { key: "failed", label: "Failed" },
];

const GenerateInvoice = ({
  generateInvoice,
  setGenerateInvoice,
  transactionsActiveTab,
}) => {
  const today = new Date().toISOString().split("T")[0];
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({ resolver: yupResolver(generateInvoiceValidation) });

  const onSubmit = async (data) => {
    try {
      const body = {
        ...data,
        payType: transactionsActiveTab,
      };
      setLoading(true);
      const response = await GenerateTransactionHistoryData(body);
      downloadExcelFile(response);
      setLoading(false);
      setGenerateInvoice(false);
    } catch (error) {
      setLoading(false);
      message.error(error?.message);
    }
    reset();
  };

  const handleFnCancel = () => {
    setGenerateInvoice(false);
    reset();
  };

  return (
    <Modal
      title="Generate Invoice"
      centered
      open={generateInvoice}
      onCancel={loading ? undefined : () => setGenerateInvoice(false)}
      footer={null}
      width={430}
    >
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <div className="flex w-full gap-x-4 mt-4">
          <div className="flex-1">
            <div className="border border-input-placeholder flex items-center gap-x-2 rounded-lg p-3 relative">
              <label
                className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1"
                htmlFor="startDate"
              >
                Start Date
              </label>
              <img src={CalendarIcon} alt="calender" />
              <input
                className="w-full outline-none text-[12px] text-input-placeholder"
                type="date"
                id="startDate"
                {...register("startDate")}
                max={today}
              />
            </div>
            <p className="text-[red] text-[12px]">
              {errors.startDate?.message}
            </p>
          </div>
          <div className="flex-1">
            <div className="border border-input-placeholder flex items-center gap-x-2 rounded-lg p-3 relative">
              <label
                className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1"
                htmlFor="endDate"
              >
                End Date
              </label>
              <img src={CalendarIcon} alt="calender" />
              <input
                className="w-full outline-none text-[12px] text-input-placeholder"
                type="date"
                id="endDate"
                {...register("endDate")}
                max={today}
              />
            </div>
            <p className="text-[red] text-[12px]">{errors.endDate?.message}</p>
          </div>
        </div>
        <div>
          <div className=" invoices border border-input-placeholder flex items-center gap-x-2 rounded-lg pl-3 py-1 relative">
            <label
              className="absolute z-40 bg-white text-input-label -top-2 left-5 text-[11px] px-1"
              htmlFor="status"
            >
              Status
            </label>
            <Controller
              control={control}
              name="paymentStatus"
              render={({ field }) => (
                <Select
                  placeholder="Select Status"
                  {...field}
                  value={field.value}
                  className="invoices w-full outline-none text-[12px] text-input-placeholder"
                  suffixIcon={<CaretDownOutlined />}
                >
                  {options?.length &&
                    options?.map((foo) => (
                      <Select.Option value={foo.key} key={foo.key}>
                        {foo.label}
                      </Select.Option>
                    ))}
                </Select>
              )}
            />
          </div>
          <p className="text-[red] text-[12px]">{errors.status?.message}</p>
        </div>

        <div className="flex gap-x-2 pt-3">
          <span
            className=" bg-white flex-1 text-center text-primary-700 border border-primary-700 text-[10px] px-6 py-3 rounded-lg cursor-pointer"
            onClick={handleFnCancel}
          >
            Back
          </span>
          <button
            disabled={loading}
            className="flex-1 text-center bg-primary-700 border border-primary-700 text-white text-[10px] px-6 py-3 rounded-lg cursor-pointer flex items-center justify-center gap-x-2"
          >
            Submit
            {loading && <span className="loader"></span>}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default GenerateInvoice;
